import styled from 'styled-components';
import { body2, colors, fontSizes, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const StyledModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.base};
  align-self: stretch;
  ${body2}
`;

export const StyledBoldText = styled.span`
  color: ${colors.textPrimary};
  font-size: ${fontSizes.s14};
  font-style: normal;
  font-weight: 700;
  line-height: ${pxToRem(20)};
`;
